
import React from 'react';
import { CheckCircle, AlertTriangle, AlertCircle } from 'lucide-react';

export const getStatusIcon = (status: string) => {
  switch (status) {
    case 'Healthy':
      return <CheckCircle className="h-4 w-4 text-green-500" />;
    case 'Warning':
      return <AlertTriangle className="h-4 w-4 text-amber-500" />;
    case 'Critical':
      return <AlertCircle className="h-4 w-4 text-red-500" />;
    default:
      return null;
  }
};

export const getStatusBadgeClass = (status: string) => {
  switch (status) {
    case 'Healthy':
      return 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400';
    case 'Warning':
      return 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400';
    case 'Critical':
      return 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400';
    default:
      return 'bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-400';
  }
};
